module.exports = __webpack_public_path__ + "static/media/vol.dd3b7f0c.svg";